/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';
import FileModal from "components/FileModal";
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { Layout } from 'components';
import ClaimsSummary from 'components/ClaimsSummary';
import ContentCard from 'components/ContentCard';
import Loader from 'components/Loader';
import Button, { ButtonContainer } from 'components/Button';
import Colors from 'constants/Colors';
import { FitinsurAPI, MessageCenter } from 'utils';
import HasPermission from 'components/HasPermission/index';
import { LostCancelButton } from 'components/index';
import {
  ButtonContent
} from './styles';

export default function ClaimComposition(props) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const formikRef = useRef(null);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [files, setFiles] = useState();
  const [isBound, setIsBound] = useState(false);

  function getFDOLpans() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetFDOLpans(props.match?.params?.idOperation)
      .then(response => response.json()).then(data => {
        setFiles(data.ret_value.documents);
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${getFDOLpans.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  async function handleOperationInfo() {
    loading.start()
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        setIsBound(response?.isBound);
        loading.stop();
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
        loading.stop();
      });
  }

  function confirmFDOLpans() {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestConfirmFDOLpans(props.match?.params?.idOperation)
      .then(response => response.json()).then(data => {
        loading.stop();
        if (data.ret_code === 200) return history.push(`/claim-composition/${props.match?.params?.idOperation}`);
        mc.error("There was an error while fetching your request");
      }).catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your request");
        console.error('fitPostSummary - Error:', error);
      });
  };


  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    loading.stop();
    getFDOLpans();
    handleOperationInfo();
  }, []);

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={'Claim ID'} subtitle={null}>
      <Formik
        innerRef={formikRef}
        initialValues={{ insurers: [], facilities: [] }}
        onSubmit={() => { }}>
        {formikProps => {
          return (
            <>
              <ClaimsSummary stage={2} idOperation={props.match?.params?.idOperation} />
              <ContentCard title="GENERATE FDO LPAN" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                <Form>
                  <FileModal idOperation={props?.match?.params?.idOperation} file={files} />
                  <ButtonContainer>
                    <Button style={{ padding: "0.75rem 1rem" }} forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                    <HasPermission permission={!isBound}>
                      <ButtonContent>
                        <LostCancelButton idOperation={props.match?.params?.idOperation} screen={"claims"}/>
                        <Button
                          primary
                          style={{ marginLeft: "10px", textAlign: "center" }}
                          onClick={() => confirmFDOLpans()}
                        >
                          CONFIRM FDO LPAN
                        </Button>
                      </ButtonContent>
                    </HasPermission>
                  </ButtonContainer>
                </Form>

                {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
              </ContentCard>
            </>)
        }}
      </Formik>
    </Layout>
  );
}
